import React from 'react';

import Menu, {ComponentProps as MenuProps} from '~/frontend/src/components/base/shared/menu/PropertiesAndReferencesSelectionMenu';

import {__} from '~/shared/src/utilities/messageCatalog';


const defaultProps = {
    buttonClassName    : 'yn-download-xml-button' as string,
    buttonIconClassName: 'pi pi-download' as string,
    buttonTooltip      : 'YN.base.common.downloadXml' as string,
    menuTitle          : 'YN.base.finder.selectPropertiesAndReferences.downloadXML.title' as string,
    menuDescription    : 'YN.base.finder.selectPropertiesAndReferences.downloadXML.text' as string,
    disabled           : false as boolean
}
type DefaultProps = typeof defaultProps;

type Props = MenuProps;

export type ComponentProps =
    Partial<DefaultProps>
    & Omit<Props, 'buttonClassName' | 'buttonIconClassName' | 'buttonTooltip' | 'menuTitle' | 'menuDescription'>;
type AllProps = DefaultProps & Props;


const DownloadXmlMenu = ( props : AllProps ) => {
    return <Menu
        {...props}
        buttonTooltip={__( props.buttonTooltip )}
        menuTitle={__( props.menuTitle )}
        menuDescription={__( props.menuDescription )}
    />;
}

DownloadXmlMenu.defaultProps = defaultProps;

export default DownloadXmlMenu;
